export const SET_SCHEMAS = 'SET_SCHEMAS';
export const GET_MANUFACTURING_DATA = 'GET_MANUFACTURING_DATA'
export const SET_MANUFACTURING_PAGINATION = 'SET_MANUFACTURING_PAGINATION'